import { cloneDeep } from "lodash";

const SET_USER_INSIGHTS_FILTERS = "app/userInsights/SET_USER_INSIGHTS_FILTERS";

const initialState = {
  userInsightsFilters: {
    segments: null,
    conversionType: null,
    markets: null
  }
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_USER_INSIGHTS_FILTERS: {
      const clonedState = cloneDeep(state);

      return {
        ...clonedState,
        userInsightsFilters: { ...clonedState.userInsightsFilters, ...action.payload }
      };
    }

    default: {
      return state;
    }
  }
}

export const setUserInsightsFilters = (filters) => ({
  type: SET_USER_INSIGHTS_FILTERS,
  payload: filters
});
